import { LocalStorageService } from '@indusoft/angular-base-services';
import $ from 'jquery';

class StorageWrapper extends LocalStorageService {
    removeAllKeysWithPrefix(prefix) {
        const allKeys = this.getAllKeys();
        const keysWithPrefix = allKeys.filter(key => key.startsWith(prefix));
        for (const key of keysWithPrefix) {
            this.deleteValue(key);
        }
    }

    item(key, value) {
        if (value === undefined) {
            return localStorage[key];
        } else {
            localStorage[key] = value;
        }
    }

    setNavMenuType(type) {
        localStorage["navMenuType"] = type;
    }

    getNavMenuType() {
        return localStorage["navMenuType"];
    }

    setIsNavMenuOpened(isOpened) {
        localStorage["isNavMenuOpened"] = isOpened ? 'true' : 'false';
    }

    getIsNavMenuOpened() {
        return localStorage["isNavMenuOpened"] !== 'false';
    }

    setSelectedTheme(theme) {
        localStorage["selectedTheme"] = theme;
    }

    setShowSwitchUi(isShow) {
        localStorage["isShowSwitchUi"] = isShow;
    }

    setNavMenuWidth(width) {
        localStorage["navMenuWidth"] = width;
    }

    getNavMenuWidth() {
        const value = localStorage["navMenuWidth"];
        return parseInt(value, 10) || 0;
    }

    setIsFullscreenEnabled(isEnabled) {
        localStorage["isFullscreenEnabled"] = isEnabled ? 'true' : 'false';
    }

    getIsFullscreenEnabled() {
        const val = localStorage["isFullscreenEnabled"];
        if (val === undefined || val === 'false')
            return false;
        return true;
    }

    getSelectedTheme() {
        return localStorage["selectedTheme"];
    }

    getShowSwitchUi() {
        const val = localStorage["isShowSwitchUi"];
        if (val === undefined || val === 'false')
            return false;
        return true;
    }

    setNavMenuFilters(filters) {
        localStorage.setItem('navMenuFilters', JSON.stringify(filters));
    }

    getNavMenuFilters() {
        const filters = localStorage.getItem('navMenuFilters');
        if (filters)
            return JSON.parse(filters);
        return null;
    }

    setFolderMenuType() {
        this.setNavMenuType('folder');
    }

    setTreeMenuType() {
        this.setNavMenuType('tree');
    }

    isFolderMenuType() {
        return this.getNavMenuType() === 'folder';
    }

    positionMainMenuScroll(value) {
        if (value === undefined) {
            const container = $('.navigation-content');
            const activeMenu = container.find(".navigation-menu.active").find("a.active");
            if (activeMenu.length > 0) {
                const menuid = activeMenu.parent().attr("data-menuid");
                localStorage['positionMainMenuScroll'] = menuid;
            }

            return localStorage['positionMainMenuScroll'];
        } else {
            localStorage['positionMainMenuScroll'] = value;
        }
    }
}

export const storageWrapper = new StorageWrapper();
export default storageWrapper;
